import { render, staticRenderFns } from "./starIcon.vue?vue&type=template&id=67ea36d4&"
import script from "./starIcon.vue?vue&type=script&lang=js&"
export * from "./starIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports